import { CommonStepId } from '@fiverr-private/identification_core';

export type StepId = CommonStepId;

export const DEFAULT_STEP_ID = 'initial' satisfies StepId;
